import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpRequest, HttpEvent } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient
  ) { }

  getHeader() {
    return new HttpHeaders({
      'Accept': 'application/json'
    })
  }

  get(url, params = {}) {
    return this.http.get(url, { headers: this.getHeader(), ...params })
  }

  post(url, body = {}, params = {}) {
    return this.http.post(url, body, { headers: this.getHeader(), ...params })
  }

  put(url, body = {}, params = {}) {
    return this.http.put(url, body, { headers: this.getHeader(), ...params })
  }

  delete(url, params = {}) {
    return this.http.delete(url, { headers: this.getHeader(), ...params })
  }

}